import { createMuiTheme } from "@material-ui/core/styles";
const defaultTheme = createMuiTheme();

const styles = {
  title: {
    disableTypography: true,
    textAlign: "left",
    color: "#1C2668",
    spacing: 12,
    fontWeight: "bold",
    fontSize: 40,
  },
  subtitle: {
    disableTypography: true,
    textAlign: "left",
    color: "#1C2668",
    spacing: 12,
    fontWeight: "bold",
    fontSize: 30,
  },
  header: {
    disableTypography: true,
    textAlign: "left",
    color: "#1C2668",
    spacing: 12,
    fontWeight: 400,
    fontSize: 24,
  },
  body: {
    disableTypography: true,
    textAlign: "left",
    color: "#25338d",
    spacing: 12,
    fontWeight: 400,
    fontSize: 18,
  },

  buttonRightHeader: {
    width: "auto",
    background: "#3246D3",
    borderRadius: "99px",
    textTransform: "none",
    fontSize: 14,
    fontWeight: 600,
    height: 48,
    padding: "0 20px",
  },
  label: {
    marginBottom: "1.5vh",
  },
  numberCircle: {
    borderRadius: "50%",
    width: "58px",
    height: "58px",
    background: "#3246D3",
    border: "2px solid #3246D3",
    textAlign: "center",
    font: "42px Arial, sans-serif",
    color: "#FFFFFF",
    fontWeight: "bold",
    fontSize: "30px",
    paddingTop: 7,
  },
  backgroundIcon: {
    borderRadius: "50%",
    width: "28px",
    height: "28px",
    background: "#ffffff",
    border: "2px solid #3246D3",
  },
  redBackgroundIcon: {
    borderRadius: "50%",
    width: "28px",
    height: "28px",
    background: "#ffffff",
    border: "2px solid #ff6666",
    color: "#ff6666 !important",
  },
  globalFormControl: {
    marginTop: defaultTheme.spacing(5),
    [defaultTheme.breakpoints.down("md")]: {
      width: 240,
    },
    [defaultTheme.breakpoints.down("sm")]: {
      width: 250,
    },
    minWidth: 200,
    width: 320,
  },
  link: {
    textDecoration: "none",
    fontWeight: 300,
    color: "#1C2668",
    "&:hover": {
      fontSize: 16,
      color: "#3246D3",
      fontWeight: 800,
    },
  },
  editLink: {
    textDecoration: "none",
    fontWeight: 400,
    color: "#1C2668",
    "&:hover": {
      fontSize: 14,
      color: "#3246D3",
      fontWeight: 800,
    },
  },
  deleteLink: {
    textDecoration: "none",
    fontWeight: 500,
    color: "#ff6666",
    "&:hover": {
      fontSize: 17,
      color: "#FF3426",
      fontWeight: 800,
      cursor: "pointer",
    },
  },
  deleteLinkWithoutFontS: {
    textDecoration: "none",
    fontWeight: 500,
    color: "#ff6666",
    "&:hover": {
      color: "#FF3426",
      fontWeight: 800,
      cursor: "pointer",
    },
  },
  detailsLink: {
    textDecoration: "none",
    fontWeight: 500,
    color: "#00cc66",
    "&:hover": {
      color: "#00994d",
      fontWeight: 800,
      cursor: "pointer",
    },
  },
  backLink: {
    textDecoration: "none",
    fontWeight: 400,
    color: "#1C2668",
    "&:hover": {
      fontSize: 16,
      color: "#3246D3",
      fontWeight: 800,
      cursor: "pointer",
    },
    position: "absolute",
    top: "120px",
    marginLeft: 40,
  },
  inputBoxSpace: {
    marginTop: "20px",
  },
  addColorButton: {
    fontSize: 12,
    width: 84,
    left: "15vw",
  },
  customSelect: {
    background: "#F9F9F9",
    border: "0.5px solid #1C2668",
    borderRadius: "99px",
    width: 200,
    mindWidth: 150,
    height: 48,
    "& .MuiOutlinedInput-root": {
      borderRadius: 99,
    },
    "& .MuiOutlinedInput-input": {
      textAlign: "center",
      color: "#1C2668",
    },
    "& .MuiSelect-select": {
      borderRadius: 99,
    },
  },
  rowHover: {
    "&:hover": {
      backgroundColor: "#ccebff !important",
      cursor: "pointer",
    },
  },
  chip: {
    width: 110,
    fontWeight: 600,
    background: "#7199ff",
    color: "white",
  },
  warningChip: {
    width: 110,
    fontWeight: 600,
    background: "#ff9933",
    color: "white",
  },
  errorChip: {
    width: 110,
    fontWeight: 600,
    background: "#ff704d",
    color: "white",
  },
  returnChip: {
    width: 110,
    fontWeight: 600,
    background: "#cccc00",
    color: "white",
  },
  successfullChip: {
    width: 110,
    fontWeight: 600,
    background: "#53c653",
    color: "white",
  },
  secondaryChip: {
    width: 110,
    fontWeight: 600,
    background: "#ff9999",
    color: "white",
  },
  siteChip: {
    color: "#ff661a",
    width: 130,
    fontWeight: 600,
    fontSize: 16,
    background: "#e1eaea",
  },
  storeChip: {
    width: 130,
    fontSize: 16,
    color: "#1C2668",
    fontWeight: 700,
    background: "#e1eaea",
  },
  lowExistence: {
    color: "red",
    width: 50,
    fontWeight: 600,
    fontSize: 16,
    background: "#e1eaea",
  },
  mediumExistence: {
    width: 50,
    fontSize: 16,
    color: "#7199ff",
    fontWeight: 800,
    background: "#e1eaea",
  },
  highExistence: {
    width: 70,
    fontSize: 16,
    color: "#53c653",
    fontWeight: 800,
    background: "#e1eaea",
  },
  chipProductType: {
    width: 150,
    fontSize: 16,
    color: " #e1eaea",
    fontWeight: 800,
    background: " #1C2668",
  },
  cashPayment: {
    width: 150,
    fontWeight: 600,
    background: " #33cc33",
    color: "white",
    "&:hover": {
      backgroundColor: "#85e085 !important",
    },
  },
  debitPayment: {
    width: 180,
    fontWeight: 600,
    background: "#1ad1ff",
    color: "white",
    "&:hover": {
      backgroundColor: "#ccf5ff !important",
    },
  },
  transfPayment: {
    width: 180,
    fontWeight: 600,
    background: "#1C2668",
    color: "white",
    "&:hover": {
      backgroundColor: "#8692df !important",
    },
  },
  pendingPayment: {
    width: 180,
    fontWeight: 600,
    background: "#c6538c",
    color: "white",
    "&:hover": {
      backgroundColor: "#df9fbf !important",
    },
  },
  creditPayment: {
    width: 180,
    fontWeight: 600,
    background: "#ffd633",
    color: "white",
    "&:hover": {
      backgroundColor: "#ffcc00 !important",
    },
  },
  statusGuarantee: {
    width: 180,
    fontSize: 16,
    color: " #e1eaea",
    fontWeight: 800,
    background: "#53c653",
  },
  blueLight: {
    width: 180,
    fontWeight: 600,
    background: "#66a3ff",
    color: "white",
  },
  backdrop: {
    zIndex: defaultTheme.zIndex.drawer + 1,
    color: "#fff",
  },
};

export default styles;
